import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { CheckEmailService, CheckPasswordService, CheckUsernameService } from '@pt/api-client';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, first, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MAIL_REGEX } from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class AsyncValidator {
  static checkEmail(service: CheckEmailService, currentUserEmail: string = null): AsyncValidatorFn {
    //todo if necessary check with regex?
    // or with validator is ok?
    if (service) {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        const value: string = control.value;
        if (value && value.match(MAIL_REGEX)) {
          return control.valueChanges.pipe(
            distinctUntilChanged(),
            debounceTime(250),
            switchMap((value) =>
              service.checkEmail(value, currentUserEmail).pipe(
                map(() => null),
                catchError(() => of({invalidAsync: true}))
              )
            )
          ).pipe(first());
        } else {
          return of({invalidAsync: true});
        }
      };
    } else {
      return null;
    }
  }

  static checkUsername(service: CheckUsernameService): AsyncValidatorFn {
    if (service) {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        return control.valueChanges.pipe(
          distinctUntilChanged(),
          debounceTime(250),
          switchMap((value) => service.checkUsername(value).pipe(
            map(() => null),
            catchError(() => of({invalidAsync: true}))
          ))
        ).pipe(first());
      };
    } else {
      return null;
    }
  }

  static checkPassword(service: CheckPasswordService): AsyncValidatorFn {
    if (service) {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        return control.valueChanges.pipe(
          distinctUntilChanged(),
          debounceTime(1250),
          switchMap((value) => {
            if (value !== '' && value !== null) {
              return service.passwordValidate(value).pipe(
                map(() => null),
                catchError(() => of({invalidAsync: true}))
              );
            } else {
              return of({invalidAsync: true});
            }
          })
        ).pipe(first());
      };
    } else {
      return null;
    }
  }


  static jsonValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      if (control && control.value) {
        try {
          JSON.parse(control.value);
          return EMPTY;
        } catch (e) {
          return of({invalidJson: 'invalid json'} as ValidationErrors);
        }
      }
      return of({invalidJson: 'invalid json'} as ValidationErrors);
    };
  }


  static dbIncidentHandling(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      if (control && control.value && !control.value.dataBreach) {
        switch (true) {
          case control.value.dataBreachReason === null:
          case control.value.dataBreachReason === undefined:
          case control.value.dataBreachReason.length === 0:
            return of({invalidAsync: true});
        }
      }
      return EMPTY;
    };
  }

}
